// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes MobileTabletShareCard_appear__sqWNZ {
    from {
        opacity: 0;
        transform: translateY(100%);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes MobileTabletShareCard_appearTablet__kGK3r {
    from {
        opacity: 0;
        transform: translateY(20px) translateX(-50%);
    }
    to {
        opacity: 1;
        transform: translateY(0) translateX(-50%);
    }
}

.MobileTabletShareCard_container__ZhcvB {
    background-color: var(--primary-dark);
    border-radius: 16px;
    color: var(--primary-light);
    padding: 30px 20px 20px 20px;
    position: fixed;
    bottom: 10%;
    left: 50%;
    z-index: 2000;
    pointer-events: visible;
    animation: MobileTabletShareCard_appear__sqWNZ 0.3s ease-out;
}

.MobileTabletShareCard_header__\\+Ffgn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: var(--font-semi-bold), sans-serif;
    font-size: var(--font-size-11);
}

.MobileTabletShareCard_buttonsContainer__F9PpD {
    display: flex;
    align-items: center;
    margin-top: 20px;
    column-gap: 10px;
}

.MobileTabletShareCard_tooltip__98zGe {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translate(-50%, -5px);
    background-color: var(--primary-dark);
    color: var(--primary-light);
    font-family: var(--font-medium), sans-serif;
    padding: 8px;
    border-radius: 4px;
    font-size: var(--font-size-4);
    white-space: nowrap;
    z-index: 1;
}

.MobileTabletShareCard_closeButton__N2tlG {
    border: none;
    background-color: var(--primary-light-02);
    border-radius: 50%;
    aspect-ratio: 1;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.MobileTabletShareCard_socialShareButton__IOklw {
    padding: 12px 14px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 6px;
    background-color: var(--primary-light-01);
    border: none;
    flex: 1 1;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease-out;
    color: var(--primary-light);
    white-space: nowrap;
}

.MobileTabletShareCard_socialShareButton__IOklw span {
    font-family: var(--font-medium), sans-serif;
    font-size: var(--font-size-4);
    height: 12px;
}

.MobileTabletShareCard_socialShareButton__IOklw:hover {
    background-color: var(--primary-light);
    color: var(--primary-dark);
}

.MobileTabletShareCard_copyright__VrVIx {
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: var(--font-size-4);
    color: var(--primary-light-05);
    text-align: center;
    margin-top: 20px;
    font-family: var(--font-light), sans-serif;
    text-decoration: none;
}

@media (max-width: 767px) {
    .MobileTabletShareCard_container__ZhcvB {
        background-color: #111018;
        border-radius: 16px 16px 0 0;
        color: #fff;
        position: fixed;
        bottom: 0;
        z-index: 2000;
        left: 0;
        right: 0;
        transform: none;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .MobileTabletShareCard_container__ZhcvB {
        padding: 24px;
        position: fixed;
        bottom: 10%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2000;
        width: 95%;
        animation: MobileTabletShareCard_appearTablet__kGK3r 0.5s ease-out;
    }
    .MobileTabletShareCard_wrapper__Bk82Q {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .MobileTabletShareCard_columnWrapper__y1AxR {
        width: 50%;
    }
}

@media (min-width: 1024px) {
    .MobileTabletShareCard_container__ZhcvB {
        padding: 24px;
        position: fixed;
        bottom: 12%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2000;
        width: 68%;
        animation: MobileTabletShareCard_appearTablet__kGK3r 0.5s ease-out;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/MobileTabletShareCard/MobileTabletShareCard.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4CAA4C;IAChD;IACA;QACI,UAAU;QACV,yCAAyC;IAC7C;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,WAAW;IACX,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,4DAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,gCAAgC;IAChC,qCAAqC;IACrC,2BAA2B;IAC3B,2CAA2C;IAC3C,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yCAAyC;IACzC,YAAY;IACZ,SAAO;IACP,eAAe;IACf,2DAA2D;IAC3D,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI;QACI,yBAAyB;QACzB,4BAA4B;QAC5B,WAAW;QACX,eAAe;QACf,SAAS;QACT,aAAa;QACb,OAAO;QACP,QAAQ;QACR,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,WAAW;QACX,SAAS;QACT,2BAA2B;QAC3B,aAAa;QACb,UAAU;QACV,kEAAqC;IACzC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,WAAW;QACX,SAAS;QACT,2BAA2B;QAC3B,aAAa;QACb,UAAU;QACV,kEAAqC;IACzC;AACJ","sourcesContent":["@keyframes appear {\n    from {\n        opacity: 0;\n        transform: translateY(100%);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes appearTablet {\n    from {\n        opacity: 0;\n        transform: translateY(20px) translateX(-50%);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) translateX(-50%);\n    }\n}\n\n.container {\n    background-color: var(--primary-dark);\n    border-radius: 16px;\n    color: var(--primary-light);\n    padding: 30px 20px 20px 20px;\n    position: fixed;\n    bottom: 10%;\n    left: 50%;\n    z-index: 2000;\n    pointer-events: visible;\n    animation: appear 0.3s ease-out;\n}\n\n.header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-family: var(--font-semi-bold), sans-serif;\n    font-size: var(--font-size-11);\n}\n\n.buttonsContainer {\n    display: flex;\n    align-items: center;\n    margin-top: 20px;\n    column-gap: 10px;\n}\n\n.tooltip {\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translate(-50%, -5px);\n    background-color: var(--primary-dark);\n    color: var(--primary-light);\n    font-family: var(--font-medium), sans-serif;\n    padding: 8px;\n    border-radius: 4px;\n    font-size: var(--font-size-4);\n    white-space: nowrap;\n    z-index: 1;\n}\n\n.closeButton {\n    border: none;\n    background-color: var(--primary-light-02);\n    border-radius: 50%;\n    aspect-ratio: 1;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.socialShareButton {\n    padding: 12px 14px;\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    column-gap: 6px;\n    background-color: var(--primary-light-01);\n    border: none;\n    flex: 1;\n    cursor: pointer;\n    transition: background-color 0.3s ease, color 0.3s ease-out;\n    color: var(--primary-light);\n    white-space: nowrap;\n}\n\n.socialShareButton span {\n    font-family: var(--font-medium), sans-serif;\n    font-size: var(--font-size-4);\n    height: 12px;\n}\n\n.socialShareButton:hover {\n    background-color: var(--primary-light);\n    color: var(--primary-dark);\n}\n\n.copyright {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    font-size: var(--font-size-4);\n    color: var(--primary-light-05);\n    text-align: center;\n    margin-top: 20px;\n    font-family: var(--font-light), sans-serif;\n    text-decoration: none;\n}\n\n@media (max-width: 767px) {\n    .container {\n        background-color: #111018;\n        border-radius: 16px 16px 0 0;\n        color: #fff;\n        position: fixed;\n        bottom: 0;\n        z-index: 2000;\n        left: 0;\n        right: 0;\n        transform: none;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1023px) {\n    .container {\n        padding: 24px;\n        position: fixed;\n        bottom: 10%;\n        left: 50%;\n        transform: translateX(-50%);\n        z-index: 2000;\n        width: 95%;\n        animation: appearTablet 0.5s ease-out;\n    }\n    .wrapper {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n    .columnWrapper {\n        width: 50%;\n    }\n}\n\n@media (min-width: 1024px) {\n    .container {\n        padding: 24px;\n        position: fixed;\n        bottom: 12%;\n        left: 50%;\n        transform: translateX(-50%);\n        z-index: 2000;\n        width: 68%;\n        animation: appearTablet 0.5s ease-out;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MobileTabletShareCard_container__ZhcvB`,
	"appear": `MobileTabletShareCard_appear__sqWNZ`,
	"header": `MobileTabletShareCard_header__+Ffgn`,
	"buttonsContainer": `MobileTabletShareCard_buttonsContainer__F9PpD`,
	"tooltip": `MobileTabletShareCard_tooltip__98zGe`,
	"closeButton": `MobileTabletShareCard_closeButton__N2tlG`,
	"socialShareButton": `MobileTabletShareCard_socialShareButton__IOklw`,
	"copyright": `MobileTabletShareCard_copyright__VrVIx`,
	"appearTablet": `MobileTabletShareCard_appearTablet__kGK3r`,
	"wrapper": `MobileTabletShareCard_wrapper__Bk82Q`,
	"columnWrapper": `MobileTabletShareCard_columnWrapper__y1AxR`
};
export default ___CSS_LOADER_EXPORT___;
